import configReducer from './config-reducer';

export default configReducer;
